import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Cookie from 'js-cookie'
import store from '@/store'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
	{
		path: '/',
		name: 'home',
		component: () => import('@/views/home/Home.vue'),
		children: [
			{
				path: '',
				name: 'main',
				component: () => import('@/views/home/Main.vue'),
			},
			{
				path: 'standards',
				name: 'standards',
				component: () => import('@/views/home/Standards.vue'),
			},
			{
				path: 'steps',
				name: 'steps',
				component: () => import('@/views/home/Steps.vue'),
			},
			{
				path: '/categories',
				name: 'categories',
				component: () => import('@/views/home/Categories.vue'),
			},
			{
				path: '/rules',
				name: 'rules',
				component: () => import('@/views/home/Rules.vue'),
			},
			{
				path: '/help',
				name: 'help',
				component: () => import('@/views/home/Rules.vue'),
			},
			{
				path: '/admin',
				name: 'admin',
				component: () => import('@/views/home/Rules.vue'),
			},
			{
				path: 'login',
				name: 'login',
				component: () => import('@/views/login/Login.vue'),
				beforeEnter(to, from, next) {
					store.commit('reset')
					next()
				},
			},
			{
				path: 'kf-guide',
				name: 'kefu',
				component: () => import('@/views/kefu/guide.vue'),
			},
		],
	},
	{
		path: '/join',
		name: 'join',
		component: () => import('@/views/join/JoinWrap.vue'),
		meta: { auth: true },
	},
	{
		path: '/authentication',
		name: 'authentication',
		component: () => import('@/views/authentication/index.vue'),
		meta: { auth: true },
	},
]

const router = new VueRouter({
	mode: 'history',
	base: '/',
	routes,
	scrollBehavior(to, from, savedPosition) {
		return savedPosition || { x: 0, y: 0 }
	},
})

router.beforeEach((to, from, next) => {
	Cookie.get('accessToken')
		? next()
		: to.meta?.auth
		? next({
				name: 'login',
				query: { redirect: to.fullPath },
				replace: true,
		  })
		: next()
})

export default router
